import logo from '../../resources/logo.png';

function IdleScreen({ onStart }) {
  return (
    <div className="h-screen w-screen relative text-white overflow-hidden animate-fadeIn">
      <img
        src="/loginscreenbackground_animated_all.svg"
        className="absolute inset-0 w-full h-full object-cover"
        alt="Background"
      />
      <div className="absolute inset-0 bg-gray-500/60" />
      <div className="relative flex flex-col items-center justify-center h-full">
        <div className="text-center mb-10 drop-shadow-lg">
          <h1 className="text-5xl font-bold mb-4">Bem-vindo!</h1>
          <p className="text-xl opacity-90">Toque para iniciar sua compra</p>
        </div>
        <button
          onClick={onStart}
          className="opacity-0 animate-fadeInDelay px-12 py-6 bg-custom_green text-white text-3xl font-semibold rounded-full shadow-xl
                     transition-all duration-300 hover:scale-105 hover:shadow-2xl
                     border-4 border-transparent hover:border-custom_yellow"
        >
          Nova compra
        </button>
      </div>
      <div className="absolute bottom-6 left-0 right-0 flex flex-col items-center opacity-90">
        <img src={logo} alt="Logo" className="w-40 mb-2 drop-shadow-md" />
        <p className="text-sm font-mono">{new Date().toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</p>
      </div>
    </div>
  );
}

export default IdleScreen;
